import { render } from "./Initiators.vue?vue&type=template&id=eb67d298"
import script from "./Initiators.vue?vue&type=script&lang=js"
export * from "./Initiators.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__